import { useEffect, useState } from 'react'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL;

export default function useDepartedSearch(query, pageNumber) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [departeds, setDeparteds] = useState([])
  const [hasMore, setHasMore] = useState(true)

  useEffect(() => {
    setDeparteds([]);
  }, [query])

  useEffect(() => {
    if (!hasMore) return;
    setLoading(true)
    setError(false)
    let cancel
    axios({
      method: 'GET',
      url: API_URL + "/departed",
      params: { page: pageNumber},
      cancelToken: new axios.CancelToken(c => cancel = c)
    }).then(res => {
      setDeparteds(prevDeparted => {
        return [...new Set([...prevDeparted, ...res?.data?.content])]
      })
      if (res?.data?.page) setHasMore(res?.data?.page?.totalPages > (pageNumber + 1))
    }).catch(e => {
      if (axios.isCancel(e)) return
      if (error?.response?.data?.code === "no_departed_found") setHasMore(false);
      if ((error?.response?.data?.code !== "no_departed_found") && (error?.response?.data?.code === "no_departed_found" && pageNumber !== 0)) {
        setError(true);
      }
    }).finally(() => {
      setLoading(false);
    });
    return () => cancel()
  }, [query, pageNumber])

  return { loading, error, departeds, hasMore }
}